// LOGIN VIEW 
export const TITLE_LOGIN = "Bienvenido a LOGYCA / COLDEX";
export const TITLE_LOGIN_DESCRIPTION = "Si usted ya cuenta con un usuario ingrese la siguiente información";
export const LABEL_EMAIL = "Correo Electrónico"
export const LABEL_PASSWORD = "Contraseña"
export const BTN_INIT_SESSION = "INICIAR SESIÓN";
export const BTN_LOAD_PROCESS = "VALIDANDO...";
export const BTN_LOAD_PROCESS_ACCOUNT_ACTIVE = "Activando Cuenta...";

// text BTN
export const BTN_UPDATE_COLDEX = "Actualizar Coldex";
export const BTN_CREATE_COLDEX = "Crear Coldex";
export const BTN_UPDATE_PERMISSION = "ACTUALIZAR";
export const BTN_ACTIVE_ACCOUNT = "ACTIVAR CUENTA";
export const BTN_PASSWORD_RECOVERY = "RECUPERAR CONTRASEÑA";

export const TITLE_PASSWORD_RECOVERY = "Recuperar Contraseña";
export const TITLE_COLDEX = "COLDEX";
export const TITLE_USERS_COLDEX = "COLDEX DISPONIBLES";
export const TITLE_ADMIN = "ADMINISTRACIÓN";
export const TITLE_REPORTS = "REPORTES";
export const TITLE_MONITORING_REPORT = "REPORTE DE SEGUIMIENTO"
export const TITLE_COLDEX_SECTION_RED = "LIDER DE RED";
export const TITLE_COLDEX_SECTION_SECTORIAL = "SECTORIAL";
export const TITLE_COLDEX_SECTION_PUBLICO = "PUBLICO";
export const TITLE_ADMIN_SECTION_USERS = "USUARIOS";
export const TITLE_SECTION_USERS_COLDEX = "USUARIOS COLDEX";
export const TITLE_POLLS_COLDEX = "CUESTIONARIOS ASIGNADOS";
export const TITLE_SECTORS_COLDEX = "SECTORES";
export const TITLE_SECTION_PADRINOS = "PADRINOS";
export const TITLE_ADMIN_SECTION_ROLES = "ROLES";
export const TITLE_ADMIN_SECTION_BUSINESS = "EMPRESAS";
export const TITLE_ADMIN_SECTION_RESOURCES = "CENTRO DE SOLUCIONES";
export const TITLE_ADMIN_SECTION_RESOURCES_USER = "CENTRO DE SOLUCIONES";
export const TITLE_MAIN = "PAGINA PRINCIPAL";
export const TITLE_INIT = "INICIO";
export const TITLE_ADMIN_SECTION_REPORTS = "GRAFICAS";
// TITLES FORM

export const TITLE_FORM_CREATE_USER = "CREAR USUARIO COLDEX";
export const TITLE_FORM_SECURITY_USER = "SEGURIDAD USUARIO";
export const TITLE_FORM_DELETE_USER = "BORRAR USUARIO COLDEX";
export const TITLE_FORM_UPDATE_USER = "ACTUALIZAR USUARIO COLDEX";
export const TITLE_FORM_CREATE_USER_PADRINO = "CREAR USUARIO COLDEX - PADRINO";
export const TITLE_FORM_UPDATE_USER_PADRINO =
"ACTUALIZAR USUARIO COLDEX - PADRINO";

export const TITLE_FORM_CREATE_COMPANY = "CREAR EMPRESA";
export const TITLE_FORM_UPDATE_COMPANY = "ACTUALIZAR EMPRESA";

export const TITLE_FORM_CREATE_COLDEX = "CREAR COLDEX";
export const TITLE_FORM_UPDATE_COLDEX = "ACTUALIZAR COLDEX";
export const TITLE_FORM_DELETE_COLDEX = "BORRAR COLDEX";
export const TITLE_FORM_PREVIEW_COLDEX = "PREVISUALIZACIÓN COLDEX";

export const TITLE_DETAILS_COLDEX = "DETALLE COLDEX";
export const TITLE_FORM_CREATE_ROLE = "CREAR ROL";
export const TITLE_FORM_UPDATE_ROLE = "ACTUALIZAR ROL";
export const TITLE_FORM_UPDATE_ROLE_PERMISSIONS = "ACTUALIZAR PERMISOS ROL";
export const TITLE_FORM_UPLOAD_TEMPLATE = "CARGAR PLANTILLA";

export const TITLE_FORM_CREATE_SECTION = "CREAR SECCIÓN";
export const TITLE_FORM_UPDATE_SECTION = "EDITAR SECCIÓN";
export const TITLE_FORM_DELETE_SECTION = "ELIMINAR SECCIÓN";

export const TITLE_FORM_CREATE_CAMPO = "CREAR CAMPO";
export const TITLE_FORM_UPDATE_CAMPO = "EDITAR CAMPO";
export const TITLE_FORM_DELETE_CAMPO = "ELIMINAR CAMPO";

export const TITLE_FORM_CREATE_RESOURCE = "CREAR RECURSO";
export const TITLE_FORM_UPDATE_RESOURCE = "EDITAR RECURSO";
export const TITLE_FORM_DELETE_RESOURCE = "BORRAR RECURSO";

//POPUPS USER

export const TITLE_WELCOME_COLDEX = "BIENVENIDO A LOGYCA / COLDEX";
export const TITLE_WELCOME_SUCCESS = "COMPLETADO";
export const TITLE_TERMS_AND_CONDITIONS ="TÉRMINOS Y CONDICIONES DE USO DE LA PÁGINA";
export const TITLE_WELCOME_USER = "BIENVENIDO A LOGYCA / COLDEX";
export const TITLE_AUTOSAVE = "Auto guardado";
export const TITLE_SEND_ANSWERS = "CUESTIONARIO ENVIADO";



export const RESULT_API_EMAIL_API = "OK"
// PERMISSION
export const USERS_PERMISSION = "USUARIOS";
export const BUSSINES_PERMISSION = "EMPRESAS";
export const ROLES_PERMISSION = "ROLES";
export const COLDEX_PERMISSION = "COLDEX";
export const RESOURCES_PERMISSION = "RECURSOS";
export const REPORTS_PERMISSION = "REPORTES";
export const CONFIG_REPORTS_PERMISSION = "CONFIGURACION DE REPORTES";
// OPTIONS
export const ACTIVE_PERMISSION = "ENABLED";
export const ACTION_BUTTON_DELETE = "DELETE";
export const ACTION_BUTTON_CREATE = "CREATE";
export const ACTION_BUTTON_UPDATE = "UPDATE";
export const ACTION_BUTTON_PREVIEW = "PREVIEW";
export const ACTION_BUTTON_TEMPLETE = "TEMPLATE";
export const ACTION_BUTTON_USERS = "USERS";
export const ACTION_BUTTON_SECURITY = "SECURITY";
export const ACTION_BUTTON_REPORTS = "REPORTS";
export const ACTION_BUTTON_MONITORING_REPORT = "MONITORING_REPORT";
export const ACTION_BUTTON_PERMISSION = "PERMISSION";
export const ACTION_BUTTON_SEND_MAIL = "SEND_MAIL";
export const ACTION_BUTTON_VIEW_RESOURCE = "VIEW_RESOURCE";
export const ACTION_BUTTON_DOWNLOAD_RESOURCE = "DOWNLOAD_RESOURCE";
// DESCRIPTION
export const CARD_DESCRIPTION_ADMIN =
  "Crea, actualiza o Elimina Usuarios, Empresas y Roles de la Plataforma.";
export const CARD_DESCRIPTION_COLDEX =
  "Crea, actualiza Coldex Lider de red, Sectorial y publicos";
export const CARD_DESCRIPTION_REPORTES = "Visualizacion de Reportes.";
export const CARD_DESCRIPTION_USERS =
  "Crea, actualiza o Elimina Usuarios de la Plataforma.";
export const CARD_DESCRIPTION_COMPANIES =
  "Crea y actualiza Empresas de la Plataforma.";
export const CARD_DESCRIPTION_ROLE =
  "Crea, actualiza y Gestina Roles y permisos por Rol de la Plataforma.";
export const CARD_DESCRIPTION_USERS_RESOURCES =
  "Administracion para la generacion de material de Apoyo enfocado al soporte del usario Coldex";
export const CARD_DESCRIPTION_COLDEX_SECTORIAL =
  "Crea, actualiza o Elimina Coldex Sectoriales.";
export const CARD_DESCRIPTION_COLDEX_RED =
  "Crea, actualiza o Elimina Coldex lider de red.";
export const CARD_DESCRIPTION_COLDEX_PUBLICO =
  "Crea, actualiza o Elimina Coldex lider de publico.";
export const USER_PASSWORD_DESCRIPTION = "Tu contraseña debe contener al menos una mayúscula, un número, una minúscula y ser de mínimo 6 caracteres"

// TITLES
export const NAME_TEMPLATE_SECTORIAL = "PlantillaColdexNN";
export const NAME_TEMPLATE_RED = "PlantillaColdexLR";
export const NAME_TEMPLATE_PUBLICO = "PlantillaAutoevaluacion";
export const VALIDATE_TEMPLATE_RED = "RED";
export const VALIDATE_TEMPLATE_SECTORIAL = "SECTORIAL";
export const VALIDATE_TEMPLATE_PUBLICO = "PÚBLICO";

export const FILTER_COLDEX_SECTORIAL_TYPE = "Sectorial";
export const FILTER_COLDEX_RED_TYPE = "Lider de Red";
export const FILTER_COLDEX_PUBLIC_TYPE = "Publico";

export const CREATE_ACTION = "create";
export const SECURITY_ACTION = "security";
export const CREATE_USER_COLDEX_ACTION = "createnew";
export const DELETE_ACTION = "delete";
export const UPDATE_ACTION = "edit";
export const PREVIEW_ACTION = "Preview";
export const REPORT_ACTION = "Report";
export const MONOTORING_REPORT_ACTION = "MONOTORING_REPORT";
export const UPLOAD_ACTION = "UploadTemplete";
export const SELECTED_ACTION = "selected";
export const CREATE_PADRINO_ACTION = "createnew";

export const VALIDATE_BOOLEAN_TRUE = "true";
export const VALIDATE_BOOLEAN_FALSE = "false";

export const DATE_TYPE_LOCAL = "datetime-local";
export const DATE_TYPE = "date";
export const PROCESS_UPDATE = "Actualizando...";
export const UPDATE_PERMISSION_ACTION = "updatePermission";
export const TEXT_INPUT_SELECT_FILE = "Seleccione un Archivo...";

export const LSPANISH_VALUE = "spanish";
export const LENGLISH_VALUE = "english";
export const CONFIG_ACTIVE = "active";
export const CONFIG_CLOSE = "closed";
export const CONFIG = "configuration";

export const OPTION_TYPE_ROLE_INACTIVE = "inactivo";
export const OPTION_TYPE_ROLE_ACTIVE = "activo";

export const OPTION_TYPE_MAIL_NOTSEND = "Correo no enviado";
export const OPTION_TYPE_MAIL_SEND = "Correo enviado";

export const BUTTON_TEXT_PADRINO = "Crear Padrino";
export const BUTTON_TEXT_USER_COLDEX = "Crear Usuario";
export const COLOR_SPINNER_LOADER = "white";
export const COLOR_SPINNER_LOADER_STADISTICS = "#00B398";

export const ID_ROL_USERCOLDEX = 3;
export const ID_ROL_ADMIN = 1;
export const ID_ROL_PADRINO = 2;
export const SIZE_SPINNER = 24;

export const SECURITY_VALIDATE_POLL = "idPoll";
export const SECURITY_VALIDATE_CATEGORY = "idCategory";
export const SECURITY_VALIDATE_POllLEVEL = "pollLevel";
export const SECURITY_VALIDATE_TDOC = "tdocCompany";
export const SECURITY_VALIDATE_NDOC = "ndocCompany";
export const SECURITY_VALIDATE_COMPANY = "company";

export const START_DATE_DEFAULT = 1;
export const END_DATE_DEFAULT = 2;
export const NUMBER_DEFAULT = -1;
export const MESSAGE_DEFAULT = "BIENVENIDO!!";
export const OPTION_COMPANY_DEFAULT = "Seleccione Compañia";
export const OPTION_COMPANY_USER_DEFAULT = "Seleccione Tipo de Empresa";
export const OPTION_ROLE_DEFAULT = "Seleccione Rol";
export const OPTION_DOCUMENT_DEFAULT = "Tipo de Documento";
export const OPTION_RESOURCES_DEFAULT = "Tipo de Recurso...";

export const OPTION_ID_DEFAULT = "default";

export const PARAMETERS_FORMS = "FormUser";
export const PARAMETERS_ROLE = "RoleType";
export const PARAMETERS_COMPANYTYPE = "CompanyType";
export const PARAMETERS_TDOCCOMPANY = "TDOCCompany";
export const PARAMETERS_CDXTYPE = "CDXTypes";
export const PARAMETERS_ICONSPOLL = "IconsPoll";

export const PARAMETER_TYPE_D = "Dimension";
export const PARAMETER_TYPE_T = "Tematica";
export const PARAMETER_TYPE_P = "Pregunta";
export const PARAMETER_TYPE_E = "Enunciado";

export const POLL_TYPE_DV = "DV";
export const POLL_TYPE_PA = "PA";
export const POLL_TYPE_AUE = "AUE";
export const POLL_TYPE_AEBL = "AEBL";

export const CREATE_COMPANY_PERMISSION_ID = 21;
export const UPDATE_COMPANY_PERMISSION_ID = 22;
export const DELETE_COMPANY_PERMISSION_ID = 23;

export const CREATE_COLDEX_PERMISSION_ID = 5;
export const UPDATE_COLDEX_PERMISSION_ID = 6;
export const DELETE_COLDEX_PERMISSION_ID = 14;
export const VIEW_COLDEX_PERMISSION_RED_ID = 27;
export const VIEW_COLDEX_PERMISSION_SECTORIAL_ID = 28;
export const VIEW_COLDEX_PERMISSION_PUBLIC_ID = 59;
export const WRITE_COLDEX_PERMISSION_ID = 29;
export const VIEW_PREVIEW_COLDEX_PERMISSION_ID = 36;
export const DOWNLOAD_TEMPLATE_COLDEX_PERMISSION_ID = 37;
export const VIEWS_COLDEX_REPORTS_PERMISSION_ID = 38;
export const CHANGE_STATE_COLDEX_PERMISSION_ID = 39;
export const VIEW_USERS_COLDEX_PERMISSION_ID = 40;

export const VIEW_USERSCOLDEX_PERMISSION_ID = 41;
export const VIEW_PADRINOCOLDEX_PERMISSION_ID = 42;

// permission userCOldex ID
export const VIEW_TABLE_USERCOLDEX_PERMISSION_ID = 43;
export const UPDATE_USERCOLDEX_PERMISSION_ID = 44;
export const CREATE_USERCOLDEX_PERMISSION_ID = 45;
export const DELETE_USERCOLDEX_PERMISSION_ID = 46;
export const SEND_EMAIL_USERCOLDEX_PERMISSION_ID = 47;
export const SET_SEGURITY_USERCOLDEX_PERMISSION_ID = 48;
export const CREATE_FROM_USERCOLDEX_PERMISSION_ID = 57;

// permission PadrinoColdexID
export const VIEW_TABLE_PADRINOCOLDEX_PERMISSION_ID = 52;
export const UPDATE_PADRINOCOLDEX_PERMISSION_ID = 55;
export const CREATE_PADRINOCOLDEX_PERMISSION_ID = 53;
export const DELETE_PADRINOCOLDEX_PERMISSION_ID = 54;
export const SEND_EMAIL_PADRINOCOLDEX_PERMISSION_ID = 56;
export const SET_SEGURITY_PADRINOCOLDEX_PERMISSION_ID = 48;
export const CREATE_FROM_PADRINOCOLDEX_PERMISSION_ID = 58;

// Permission Security Coldex
export const VIEW_TABLE_SECURITYUSERCOLDEX_PERMISSION_ID = 49;
export const CREATE_SECURITYUSERCOLDEX_PERMISSION_ID = 50;
export const DELETE_SECURITYUSERCOLDEX_PERMISSION_ID = 51;

// Permission Resources
export const CREATE_RESOURCES_PERMISSION_ID = 31;
export const UPDATE_RESOURCES_PERMISSION_ID = 32;
export const VIEW_RESOURCES_PERMISSION_ID = 61;
export const CONFIG_RESOURCES_PERMISSION_ID = 60;
export const DELETE_RESOURCES_PERMISSION_ID = 64;
export const UPDATE_RESOURCESSECTION_PERMISSION_ID = 65;
export const CREATE_RESOURCESSECTION_PERMISSION_ID = 66;

export const MAX_LENGTH_WINDOW = 1024;

// PERMISSION ID FOR VIEW REPORTS IN MENU (DEPRECATED IN DISUSES)
export const VIEW_COLDEX_REPORTS_PERMISSION_ID = 35;

export const CREATE_USER_PERMISSION_ID = 2;
export const UPDATE_USER_PERMISSION_ID = 3;
export const DELETE_USER_PERMISSION_ID = 12;

export const CREATE_ROLE_PERMISSION_ID = 19;
export const UPDATE_ROLE_PERMISSION_ID = 17;
export const DELETE_ROLE_PERMISSION_ID = 18;
export const VIEW_ROLE_PERMISSION_ID = 11;

// ID's REPORTS MANAGE
export const REPORTS_GRAPHIC_ZERO_ID = 0
export const REPORTS_GRAPHIC_ONE_ID = 1
export const REPORTS_GRAPHIC_TWO_ID = 2
export const REPORTS_GRAPHIC_THREE_ID = 3
export const REPORTS_GRAPHIC_FOUR_ID = 4
export const REPORTS_GRAPHIC_FIVE_ID = 5
export const REPORTS_GRAPHIC_SIX_ID = 6
export const REPORTS_GRAPHIC_SEVEN_ID = 7
export const REPORTS_GRAPHIC_EIGHT_ID = 8
export const REPORTS_GRAPHIC_NINE_ID = 9
export const REPORTS_GRAPHIC_TEN_ID = 10
export const REPORTS_GRAPHIC_ELEVEN_ID = 11
export const REPORTS_GRAPHIC_TWELVE_ID = 12
export const REPORTS_GRAPHIC_THIRTEEN_ID = 13
export const REPORTS_GRAPHIC_FOURTEEN_ID = 14
export const REPORTS_GRAPHIC_FIVETEEN_ID = 15



export const TEXT_POLL_DV =
  ": En el costado derecho encontraras cada uno de los socios de negocio que te corresponde evaluar. Selecciona una única opción por aliado, en los niveles de 1 a 4 siendo 1 el nivel más bajo y 4 el nivel más alto de acuerdo con el enunciado que lo acompaña, si por alguna razón no deseas contestar a la pregunta puedes colocar No Aplica.";
export const TEXT_POLL_TITLE_DV = "CUESTIONARIO DOBLE VÍA";
export const TEXT_POLL_SUBTITLE_DV = "DOBLE VÍA";

export const TEXT_POLL_PA =
  ": Escribe tus comentarios para tus principales socios de negocio, recomendamos redactar de manera respetuosa y manteniendo las normas ortográficas";
export const TEXT_POLL_TITLE_PA = "CUESTIONARIO PREGUNTAS ABIERTAS";
export const TEXT_POLL_SUBTITLE_PA = "PREGUNTAS ABIERTAS";

export const TEXT_POLL_AUE =
  ": Califica cada temática de la matriz, en los niveles de 1 a 4 siendo 1 el nivel  más bajo y 4 el nivel más alto de acuerdo con el enunciado que lo acompaña.";
export const TEXT_POLL_TITLE_AUE = "CUESTIONARIO AUTOEVALUACIÓN";
export const TEXT_POLL_SUBTITLE_AUE = "AUTOEVALUACION";

export const TEXT_POLL_EXPLANATION =
  "Para enviar tus respuestas debes completar todo el cuestionario, si cierras la ventana sin haber terminado se guardarán las preguntas y podrás continuar más tarde, asegúrate de tomar el tiempo suficiente para responder y enviar.";

export const ICON_QUESTION_ANSWER = "question_answer";

export const VALIDATE_TYPE_ERROR = "ERROR";
export const VALIDATE_TYPE_SUCCESS_ACTIVE = "Operación Completa";
export const VALIDATE_TYPE_SUCCESS = "SUCCESS";
export const VALIDATE_TYPE_WARNING = "WARNING";
export const VALIDATE_TYPE_ACTIVE = "activada";


export const TEXT_WELCOME_COLDEX_1 = "Tienes disponible ";
export const TEXT_WELCOME_COLDEX_2 =
  " cuestionarios por diligenciar, los cuales estarán habilitados hasta el ";
export const TEXT_WELCOME_COLDEX_3 =
  " .";

export const TEXT_COMPLETE_COLDEX =
  "Ya completaste todos los cuestionarios por diligenciar. ¡Gracias por participar!";
  
export const SUBTITLE1_TERMS_AND_CONDITIONS = "Certificación de información";
export const TEXT1_TERMS_AND_CONDITIONS =
  "Certifico que la información suministrada en el momento del registro será verídica y corresponde a la compañía registrada.";
export const SUBTITLE2_TERMS_AND_CONDITIONS = "Privacidad";
export const TEXT2_TERMS_AND_CONDITIONS =
  "GS1 Colombia da una importancia relevante a la adopción e implementación de medidas que aseguren la privacidad de los usuarios de este web site. Cuando usted visita nuestro web site, nosotros no mantenemos datos o registros sin la autorización y la debida inscripción del cliente. Su dirección IP (Dirección de internet en su computador) será utilizada únicamente para asistirnos en la medida del tráfico en nuestro sitio y para permitirnos mejorar la calidad del servicio que le ofrecemos por medio de este web site. Recolectaremos su información personal únicamente con su consentimiento dando cumplimiento a nuestra política de autorización para el tratamiento de datos según la ley estatutaria 1581 del 17 de octubre de 2012. Disponible en: http://www.logyca.com/Portals/2/Documentos/MANUAL_POLITICA_GS1_LEY_15 81.pdf";
export const SUBTITLE3_TERMS_AND_CONDITIONS =
  "La cual manifiesta lo siguiente:";
export const TEXT3_TERMS_AND_CONDITIONS =
  "GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S podrán usar mi información para los siguientes fines: (i) Efectuar las gestiones pertinentes para el desarrollo de la etapa precontractual, contractual y pos contractual con GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S y sus aliados estratégicos, respecto de cualquiera de los productos ofrecidos por ellas que haya o no adquirido o respecto de cualquier relación precontractual o contractual subyacente que tenga con ella, así como dar cumplimiento a la ley colombiana o extranjera y a las órdenes de autoridades judiciales o administrativas; (ii) Realizar invitaciones a eventos, mejorar productos y servicios u ofertar nuevos productos, y todas aquellas actividades asociadas a la relación comercial o vínculo existente con GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S y sus aliados estratégicos, o aquel que llegare a tener; (iii) Gestionar trámites (solicitudes, quejas, reclamos) realizar análisis de riesgo, efectuar encuestas de satisfacción respecto de los bienes y servicios de GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S, así como a los aliados comerciales de GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S y sus aliados estratégicos; (iv) Suministrar información de contacto a la fuerza comercial y/o red de distribución y telemercadeo; (v) Suministrar información de contacto y documentos pertinentes recibidos del cliente o potencial cliente a los aliados estratégicos. con las cuales GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S posean un vínculo contractual para la distribución de sus productos y servicios; (vi) Transferir y/o trasmitir los datos personales para implementar servicios de computación en la nube; (vii) Crear bases de datos para los fines descritos en la respectiva autorización; (viii) Enviar invitaciones a eventos, campañas, lanzamientos de producto por medios telefónicos, electrónicos (SMS, chat, correo electrónico y demás medios considerados electrónicos) físicos y/o personales; (ix) Realizar grabación de las llamadas que realicen los titulares de los datos como soporte ante quejas y reclamos. Otorgo mi consentimiento a GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S para tratar mi información personal, de acuerdo con la política de tratamiento de datos personales, y por tanto me comprometo a leer la política mencionada disponible en: http://www.logyca.com/Portals/2/Documentos/MANUAL_POLITICA_GS1_LEY_1581.pdf Autorizo a GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S a modificar o actualizar su contenido, a fin de atender reformas legislativas, políticas internas o nuevos requerimientos para la prestación u ofrecimiento de servicios o productos, dando aviso previo por medio de la página web de la compañía, y/o correo electrónico. La información del formato del cual forma parte la presente autorización la he suministrado de forma voluntaria y es verídica. ¹Son datos sensibles, aquellos que afectan la intimidad del Titular o cuyo uso indebido puede generar discriminación, por ejemplo la orientación política, las convicciones religiosas o filosóficas, de derechos humanos así como los datos relativos a la salud, a la vida sexual. Autorizo a GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S a compartir mi información con aliados estratégicos y/o terceros. Cuando usted decide dar información personal a GS1 Colombia por alguna de las razones anteriormente descritas, nosotros haremos todo lo correspondiente a implementar la última tecnología que lleve a proteger su información personal. GS1 COLOMBIA, FUNDACIÓN LOGYCA / INVESTIGACIÓN y LOGYCA / SERVICIOS S.A.S no venderá o compartirá su información personal. Este sitio web contiene vínculos a otros sitios web. GS1 Colombia no es responsable de las prácticas privadas o el contenido de estos sitios. Si tiene alguna pregunta acerca de nuestra póliza de privacidad, o si desea corregir o actualizar su información personal de nuestro sitio web correspondiente a GS1 Colombia, por favor contáctenos a web@gs1co.org En caso que el cliente no envié la No aceptación a la Política de Tratamiento de Información, se tomara al pie de la letra y a conformidad lo que expresa el numeral 4 del artículo 10 del decreto 1377.";

export const TEXT1_WELCOME_USER =
  "Bienvenido a la plataforma LOGYCA / COLDEX. Un espacio diseñado para que fortalezcas las relaciones con tus socios de negocio, conoce el nivel de colaboración de tu organización, aprende sobre tendencias y metodologías de colaboración.";
//pop up dispositivo no soportado
export const TITLE_LOGYCA = "LOGYCA / COLDEX";
export const TEXT_DEVICE_DENIED =
  "LOGYCA / COLDEX te informa que la pataforma no esta disponible para dispositivos moviles";
//POP UP AUTO SAVE
export const TEXT_AUTOSAVE = "¿Desea Autoguardar? (no se podrán cambiar)";

//POP UP Send
export const TEXT_SEND_ANSWERS =
  "Te faltan preguntas por responder, ¿Deseas guardar tus respuestas?  (no las podrás cambiar )";
export const TEXT_SEND_ANSWERS_CONFIRMATION =
  "Gracias por tus respuestas, luego puedes consultarlas sin la posibilidad de edición";
export const TEXT_ANSWERS_COMPLETE =
  "Ya contéstate este cuestionario al 100%, recuerda que puedes visualizar tus respuestas mas no editarlas";

export const REPORT_PERMISSION_VIEW_ALL_COMPANY = "VIEW_ALL_COMPANY";
export const REPORT_PERMISSION_VIEW_ONLY_COMPANY = "VIEW_ONLY_COMPANY";

export const REPORT_NOT_PLOT_AVAILABLE = "Grafica no disponible";
export const REPORT_PLOT_LOADING = "Cargando grafica ...";

export const REPORT_HEADERS = {
  historic_scatter: {
    title: "Gráfico de Dispersión ",
    description:
      "Conozca la evolución del índice de colaboración a través de los años, en la siguiente grafica usted puede visualizar el indicador COLDEX de empresas de los diferentes sectores desde el 2017 hasta el año actual. Además tiene la opción de filtrar por cada sector y conocer el indicador general del sector y el indicador general del año que es el promedio de todos los sectores. Si lo desea también tiene la posibilidad de ver la información de solo un año.",
  },
  historic_ranking: {
    title: "Desempeño histórico puesto ranking  general ",
    description:
      "Conozca el top 5 de las empresas en esta versión de COLDEX y la posición que han ocupado en el ranking de COLDEX en los últimos años, Visualice tambien su posición en relación a ellas y si esa posición se ha mantenido, aumentado o disminuido a través del tiempo.",
  },
  performance_index_coldex: {
    title: "Desempeño histórico índice coldex general",
    description:
      "Conozca la evolución del indicador COLDEX de su organización a través de los años incluyendo el año actual, identifique la línea de crecimiento o decrecimiento tanto de su empresa como de los demás participantes del sector. También puede observar la calificación más alta en cada año para alguna de las empresas participantes.",
  },
  performance_aspects: {
    title: "Gráfico de barras Desempeño por aspectos",
    description:
      "En el siguiente gráfico verá un análisis mucho más específico que le permitirá conocer cual fue la evaluación por cada uno de los aspectos evaluados, este el nivel mas detallado dentro del informe. Cada aspecto corresponde a cada pregunta evaluada. Además puede ver cual fue la calificación mas alta que otorgo ese socio de negocio a alguna de las empresas evaluadas y así conocer la brecha que tenemos frente a esa empresa referente. ",
  },
  table_general: {
    title: "Ranking Tabla (General y por dimensión)",
    description:
      "Benchmarking colaborativo, identifique a las empresas lideres en colaboración y su posición frente a ellas, esta tabla le permitirá conocer la dispersión del indicador COLDEX para las empresas que participaron en el sector, así identificara a partir de su calificación, la calificación máxima y la mínima la brecha que tiene para ser el referente.",
  },
  performance_index: {
    title: "Gráfico de barras Desempeño por aspectos",
    description:
      "Identifique los aspectos con mayor brecha frente al referente, al trabajar en estos aspectos logrará mejores resultados. ",
  },
  spider: {
    title: "Gráfico radial (Dimensión y temáticas)",
    description: `Detecte fortalezas y oportunidades de mejora por las temáticas evaluadas. \n
      El color del cuadro que enmarca la temática le permite identificar a cual de las 3 dimensiones pertenece, adicional usted puede comparar la calificación general de su organización con la del promedio de las demás empresas del sector, el mínimo y máximo. De esta manera comprender si tiene allí una fortaleza frente a sus competidores o una oportunidad para mejorar.`,
  },
  historic_block: {
    title: "Desempeño histórico por bloques general",
    description:
      "Conozca el desempeño por dimensión de su organización; aquí podrá ver el comportamiento  con la calificación de la medición anterior y con el referente entre las demás empresas del sector.  Adicional el gráfico le permite identificar la brecha porcentual entre su empresa y el referente en cada una de las dimensiones y así priorizar la de mayor brecha.",
  },
  ubication_by_block: {
    title: "Tabla de ubicación por bloque temático",
    description: `En la siguiente tabla puede visualizar en doble vía el nivel de madurez en el que lo percibe su socio de negocio, por cada dimensión y el nivel en el que desde su organización perciben a su socio de negocio. 

      Identifique las brechas frente a la forma como su organización percibe a su socio de negocio y como este percibe a su organización. 
      `,
  },
  roadmap: {
    title: "Hoja de ruta mapa de calor sectorial",
    description:
      `Mapa de calor que representa las fortalezas y principales oportunidades de mejora.

      El color le indica en que nivel de madurez en colaboración se encuentra por temática con cada uno de sus socios de negocio. El porcentaje indica el avance que tiene para ser el referente, es decir si su calificación es de 100% indica que su empresa es el referente  quien obtuvo la calificación mas alta para ese socio en esa temática. Si su calificación es 80% entonces su empresa tiene una brecha del 20% para llegar a ser  una  empresa referente.
      `,
  },
  quartils_thematic: {
    title: "Gráfico de cuartiles (Temáticas)",
    description:
      "Visualice la dispersión de la calificación general de COLDEX de las diferentes empresas del sector en cada una de las temáticas (puntos blancos) y ubique en relación a estas donde se encuentra su empresa (triangulo) dentro de los 4 cuadrantes, siendo el nivel 4 el cuadrante de aquellas empresas que presentan una fortaleza en esa temática y el nivel 1 el cuadrante de aquellas empresas que deben priorizar como oportunidad de mejora esa temática.",
  },
  evaluator_historic_ranking: {
    title: "Desempeño histórico puesto ranking  general ",
    description:
      "Conozca la posición que ha ocupado en el ranking de COLDEX en los últimos años para un socio de negocio en particular, filtre en el campo –evaluador- por el socio de negocio que desee observar. Esta acción le permitirá visualizar el top 5 de las empresas calificadas por su socio de negocio, su posición en relación a ellas y si esa posición se ha mantenido, aumentado o disminuido a través del tiempo.",
  },
  evaluator_performance_index_coldex: {
    title: "Desempeño histórico índice coldex general",
    description:
      "Conozca la evolución del indicador COLDEX de su organización de acuerdo a como lo calificó un socio de negocio especifico a través de los años incluyendo el año actual, filtre de acuerdo al socio que desee observar; compárelo con la calificación de años anteriores, identifique la línea de crecimiento o decrecimiento tanto de su empresa como de los demás participantes del sector. También puede observar la calificación más alta que ese socio le otorga a alguna de las empresas participantes.",
  },
  evaluator_historic_block: {
    title: "Desempeño histórico por bloques general",
    description:
      "Conozca el desempeño por dimensión de su organización de acuerdo a como lo calificó un socio de negocio especifico, filtre de acuerdo al socio que desee observar; compárelo con la calificación de la medición anterior y con el referente como ese socio de negocio calificó a las demás empresas del sector. Adicional el gráfico le permite identificar la brecha porcentual entre su empresa y el referente en cada una de las dimensiones y así priorizar la de mayor brecha.",
  },
  evaluator_spider: {
    title: "Gráfico radial (Dimensión y temáticas)",
    description: `Detecte fortalezas y oportunidades de mejora por las temáticas evaluadas.
    El color del cuadro que enmarca la temática le permite identificar a cual de las 3 dimensiones pertenece,
    adicional usted puede comparar la calificación que le otorgo su socio de negocio con la del promedio que le calificó a las
    demás empresas del sector, el mínimo y máximo. De esta manera comprender si tiene allí una fortaleza frente a sus competidores
    o una oportunidad para mejorar. 
    `,
  }
};

//RESOURCES AND TABLES

export const PARAMETERS_SECTIONTYPE = "RTypes";


// BUTTONS RESOURCES

export const ACTION_BUTTON_VIDEO = "Video";
export const ACTION_BUTTON_IMAGES = "Imagen";
export const ACTION_BUTTON_DOCUMENTS = "Documento";
export const ACTION_BUTTON_LINKS = "Link";
export const CONFIG_ACTION = "Config";
export const OPTION_TYPE_FORM_ACTIVE = "Activo";
export const OPTION_TYPE_FORM_INACTIVE = "Inactivo";
export const PARAMETERS_RFORM = "RFormsType";
export const OPTION_RFORM_USER_DEFAULT = "Seleccione Tipo de campo...";
export const OPTION_RESOURCES_USER_DEFAULT = "Seleccione Tipo de recurso...";
export const OPTION_SECCION_USER_DEFAULT = "Seleccione Tipo de seccion...";
export const PARAMETERS_RESOURCESTYPE = "RResourcesType";

export const RESOURCE_TYPE_FORMS = "Formulario"
export const RESOURCE_TYPE_RESOURCES = "Recursos"


// FORMS LABELS

export const LABEL_DOC_TYPE = "Tipo de documento"
export const LABEL_COMPANY_TYPE = "Tipo de compañía"
export const LABEL_COMPANY_NAME = "Nombre compañía"
export const LABEL_DOC_NUMBER = "Número de documento"
export const LABEL_STATE = "Estado"

export const LABEL_NAME = "Nombre"
export const LABEL_LASTNAME = "Apellido"
export const LABEL_PHONE = "Número de celular"
export const LABEL_LOGIN_STATE = "Ha iniciado sesión"

export const LABEL_YEAR = "Año"
export const LABEL_COUNTRY  = "País"
export const LABEL_TYPE = "Tipo"
export const LABEL_START_DATE = "Fecha de inicio"
export const LABEL_END_DATE = "Fecha de fin"
export const LABEL_DESCRIPTION = "Descripción"

export const LABEL_ORDER = "Orden"
export const LABEL_PRIORITY = "Prioridad"
export const LABEL_FILE = "Elegir archivo"
export const LABEL_ROLE = "Rol"
export const LABEL_POSITION = "Cargo"

// Emails
export const ERROR_UPDATE_TEMPLATE = 'Object reference not set to an instance of an object.'
export const PASSWORD_RECOVERY_TEXT = "Te enviaremos un correo electrónico con tu contraseña"

// subjects Email
export const SUBJECT_REGISTER_FORM_CONTACT = "Centro de Soluciones – Solicitud Caso de Soporte"
export const SUBJECT_REGISTER_REMEMBER_PASSWORD = "Recordatorio de contraseña plataforma LOGYCA / COLDEX";
export const SUBJECT_REGISTER_REMEMBER_REPORT = "Recordatorio de reporte LOGYCA / COLDEX";


export const VALIDATE_PASSWORD = "/^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/"



// ! Management Download Data Result graphics Radial and Quartils

export const RADIAL_GRAPHIC = 'RADIAL'
export const QUARTIL_GRAPHIC = 'CUARTIL'